export const revenueData2 = {
  labels: "",

  datasets: [
    {
      label: "",

      data: "",

      backgroundColor: "rgba(9, 93, 227)",
      lineTension: 0,
      borderRadius: 0,
      borderColor: "rgba(9, 93, 227)",

      borderWidth: 2,
      barThickness: 35,
      yAxisID: "y-axis-1",
    },
    {
      label: "SPY",

      data: "",

      backgroundColor: "rgba(126, 132, 140)",

      borderRadius: 0,
      lineTension: 0,

      borderColor: "rgba(126, 132, 140)",
      borderWidth: 2,

      yAxisID: "y-axis-2",
    },
  ],
};
